import { animate, state, style, transition, trigger } from '@angular/animations';

export const toastAnimations = {
  toastAnimation: trigger('toastAnimation', [
    state(
      'void',
      style({
        transform: 'translateX(100%)',
        opacity: 0,
      })
    ),
    state(
      'visible',
      style({
        transform: 'translateX(0)',
        opacity: 1,
      })
    ),
    state(
      'hidden',
      style({
        transform: 'translateX(100%)',
        opacity: 0,
      })
    ),
    transition('void => visible', animate('200ms ease-out')),
    transition('visible => hidden', animate('200ms ease-in')),
  ]),

  progressAnimation: trigger('progressAnimation', [
    state('start', style({ width: '0%' })),
    state('end', style({ width: '100%' })),
    transition('start => end', animate('{{duration}}ms linear')),
  ]),
};
